import React from 'react';
import { ClbButton } from '@celebration/react/ClbButton/ClbButton';
import { ButtonProps } from '@celebration/react/ClbButton/ClbButton.types';
import { ClbButtonGroup } from '@celebration/design-system/dist/lib/button-group';
import { createComponent } from '@lit-labs/react';

import './button-group.scss';

export default createComponent({
    react: React,
    elementClass: ClbButtonGroup,
    tagName: ClbButtonGroup.tagName,
    events: ClbButtonGroup.events,
});

export interface IButtonGroupProps {
    slot?: string;
    buttons: ButtonProps[];
    dataTestId: string;
}

export function ButtonGroup({
    buttons,
    dataTestId,
}: Readonly<IButtonGroupProps>) {
    return (
        <div className="toolbar-button-action-groups" data-testid={dataTestId}>
            {buttons.map(props => (
                <ClbButton {...props} />
            ))}
        </div>
    );
}
